import React from 'react'
import '../css/aboutUs.css'
 function AboutUs() {
  return (
    <div class="  about p-2 " id="about">
      <div class="text-dark fs-2 text-center my-4 ">
         About Us
        </div>      
        <div  class="  p-3" id="containerabout">    
         <div class="p-1 "  data-aos="fade-up"  data-aos-easing="ease-out-cubic"
     data-aos-duration="1500">
      <div class="d-flex row">
        <div class=" col-sm-12 col-md-12 col-lg-6  d-flex  justify-content-center align-items-center" >
          <div class="d-flex  p-1 ">
          <img src="/assets/webdev1.png" class=" img img-fluid" alt="test image" id="aboutimg" />   
          </div>          
        </div>
        <div class=" col-sm-12 col-md-12 col-lg-6 p-3  d-flex  justify-content-center align-items-center" >
          <div class="m-3">       
          <p  class=" fs-5  text-dark ">
           {/* We are a team of experienced developers, designers, and project managers dedicated to delivering high-quality software solutions that meet our clients' needs. Our goal is to help businesses stay competitive in today's rapidly evolving technological landscape.
we specialize in custom software development, mobile app development, web development. We have a proven track record of delivering innovative and scalable solutions for our clients across a range of industries.
Our team has expertise in a wide range of technologies, including Java, Python, Ruby on Rails, React, Node.js, and more. We stay up-to-date with the latest trends and best practices in software development to ensure that our clients receive the best possible solutions.
We take pride in our transparent and collaborative approach to project management. Our process involves working closely with our clients to define their requirements, develop a roadmap, and deliver solutions that meet their needs on time and within budget.
We understand that each project is unique, and we strive to provide tailored solutions that meet our clients' specific needs. Whether you need a simple mobile app or a complex enterprise-level software solution, we have the skills and experience to deliver.
 Please don't hesitate to contact us to learn more about how we can help your business grow and succeed in today's digital landscape.   */}

 We are a group of skilled programmers, designers, and project managers committed to providing high-caliber software solutions that satisfy the demands of our customers. Our objective is to assist companies in remaining competitive in the quickly changing technology environment of today.
Web development, mobile app development, and custom software development are our areas of expertise. We have a track record of providing our clients with creative and scalable solutions across a variety of industries.
A variety of technologies, including Java, Python, Ruby on Rails, React, Node.js, and others, are well-versed by our staff. To ensure that our clients receive the finest possible solutions, we stay current with the newest trends and practices in software development.
We take pride in the openness and cooperation with which we manage projects.   
         </p>
         </div>
        </div>
      </div>
    </div>    
  </div>
      </div>
  
  )
}
export default AboutUs;